import React from 'react';
import { useData } from '../store/DataContext';
import { AdminDashboard } from './admin/AdminDashboard';
import { ReceptionDashboard } from './reception/ReceptionDashboard';
import { NursingDashboard } from './nursing/NursingDashboard';
import { ClinicianDashboard } from './clinician/ClinicianDashboard';
import { LaboratoryDashboard } from './laboratory/LaboratoryDashboard';
import { RadiologyDashboard } from './radiology/RadiologyDashboard';
import { PharmacyModule } from './pharmacy/PharmacyModule';
export const DashboardRouter: React.FC = () => {
  const {
    currentUser
  } = useData();
  if (!currentUser) return null;
  switch (currentUser.role) {
    case 'Administrator':
      return <AdminDashboard data-id="element-2333" />;
    case 'Reception':
      return <ReceptionDashboard data-id="element-2334" />;
    case 'Nursing':
      return <NursingDashboard data-id="element-2335" />;
    case 'Clinician':
      return <ClinicianDashboard data-id="element-2336" />;
    case 'Laboratory':
      return <LaboratoryDashboard data-id="element-2337" />;
    case 'Radiology':
      return <RadiologyDashboard data-id="element-2338" />;
    case 'Pharmacy':
      return <PharmacyModule data-id="element-2339" />;
    default:
      return <div data-id="element-2340">Unknown role</div>;
  }
};